import createNormalizer from 'utils/createNormalizer';
import {
  modelsWithTemplatesSpecsSchemaEntity,
  modelsWithTemplatesWorkingState,
  modelWithCurrentViewer,
} from '../schemas';

export const normalizeModelTemplatesSpecs = createNormalizer({
  model: modelsWithTemplatesSpecsSchemaEntity,
});

export const normalizeModelTemplatesWorkingState = createNormalizer({
  model: modelsWithTemplatesWorkingState,
});

export const normalizeModelsViewer = createNormalizer({
  models: [modelWithCurrentViewer],
});

export const normalizeModelViewer = createNormalizer({
  model: modelWithCurrentViewer,
});
